import { Component } from '@theme/component'

class PolicySwitcher extends Component {
  requiredRefs = ['policyLink', 'policyDoc']

  mounted() {
    const index = this.#indexOf(this.#handleFromHash())
    this.#select(index === -1 ? 0 : index)
  }

  selectPolicy({ handle }, event) {
    const index = this.#indexOf(handle)

    if (index === -1) {
      return
    }

    event.preventDefault()
    this.#select(index)
    history.replaceState(null, '', `#${handle}`)
  }

  #select(index) {
    const doc = this.refs.policyDoc[index]

    if (!doc) {
      return
    }

    doc.open = true
    this.#markCurrentLink(index)
  }

  #markCurrentLink(index) {
    this.refs.policyLink.forEach((link, position) => {
      if (position === index) {
        link.setAttribute('aria-current', 'true')
        return
      }
      link.removeAttribute('aria-current')
    })
  }

  #indexOf(handle) {
    if (!handle) {
      return -1
    }
    return this.refs.policyDoc.findIndex(
      (doc) => doc.dataset.policyHandle === handle
    )
  }

  #handleFromHash() {
    const raw = window.location.hash.slice(1)

    if (!raw) {
      return ''
    }

    try {
      return decodeURIComponent(raw)
    } catch {
      return ''
    }
  }
}

if (!customElements.get('ui-policy-switcher')) {
  customElements.define('ui-policy-switcher', PolicySwitcher)
}
